import React, { useState, useEffect } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Collapse,
  TableRow,
  TableCell,Link,
} from '@material-ui/core';
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import SortableTable from "../shared/Tables/SortableTable";
import {Skeleton} from "@material-ui/lab";
import {toTitleCase} from "../../../helpers/utils";

const PreDraftContactsSection = ({ contacts, fetching, open,handleOpenContactModal, ...props }) => {
  const [expandContacts, setExpandContacts] = useState(open);

  const toggleExpandContacts = () => {
    setExpandContacts(!expandContacts);
  }


  return(
    <React.Fragment>
      <Card style={{marginTop: '24px'}}
      >
        <CardHeader className='cursor-pointer' title={
            <span>
              <span>Contacts</span>
              <span className='float-right'>
                {
                  expandContacts ? <ExpandLess /> : <ExpandMore />
                }
              </span>
            </span>
          } onClick={toggleExpandContacts}
        />
        <Divider />
        <CardContent style={{padding: `${expandContacts ? '20px' : 0}`, overflowY: 'auto'}}>
          <Collapse in={expandContacts}>
            {
              fetching ? <Skeleton animation='pulse' variant='rect' height='100px' width='100%' component='div' /> : <SortableTable
                  headCells={[
                    { id: 'first_name', numeric: false, disablePadding: false, label: 'First Name ' },
                    { id: 'last_name', numeric: false, disablePadding: false, label: 'Last Name ' },
                    { id: 'ria_contact_crd_id', numeric: false, disablePadding: false, label: 'CRD ' },
                  ]}
                  rows={contacts}
                  rowsPerPageDefault={50}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  RowRenderer={
                    (row, _isSelected, index, _handleCheck) => (<TableRow
                        hover
                        tabIndex={-1}
                        key={row.id}
                        style={{cursor: "pointer"}}
                        onClick={(event) => (row.id)}
                    >
                      <TableCell>
                        <Link onClick={(event) => handleOpenContactModal(row.ria_contact_crd_id, index)}>
                          {toTitleCase(row.first_name)}
                        </Link>
                      </TableCell>
                      <TableCell>
                        <Link onClick={(event) => handleOpenContactModal(row.ria_contact_crd_id, index)}>
                          {toTitleCase(row.last_name)}
                        </Link>
                      </TableCell>
                      <TableCell>{row.ria_contact_crd_id}</TableCell>
                    </TableRow>)
                  }
              />
            }
          </Collapse>
        </CardContent>
      </Card>
    </React.Fragment>
  )
}

export default PreDraftContactsSection;